<style lang="less" scoped></style>

<template>
  <div class="detail-container">
    <div class="detail-bread-crumb-div">
      <ZD-bread-crumb
        :bConfigList="pageConfig.detailBreadCrumb"
      ></ZD-bread-crumb>
    </div>
    <div class="detail-content-div">
      <div class="detail-content-header-div flex">
        <div class="left-page-title-div flex-1">{{ pageTitle }}</div>
      </div>
      <div class="detail-content-body-div flex-1">
        <el-form
          :model="detailForm"
          :rules="pageConfig.contractRules"
          ref="detailForm"
          label-width="120px"
          class="detail-form"
        >
          <div class="flex detail-form-parent-div">
            <div class="flex-1">
              <el-form-item label="签约时间" prop="contractBeginTime">
                <el-date-picker
                  v-model="detailForm.contractBeginTime"
                  type="date"
                  placeholder="选择签约时间"
                  
                  value-format="yyyy-MM-dd">
                </el-date-picker>
              </el-form-item>
              <el-form-item label="结算周期" prop="settlementCycle">
                <el-select
                  class="full-width"
                  v-model="detailForm.settlementCycle"
                  size="small"
                  clearable
                  @change="handelChange"
                >
                  <el-option label="一次性" :value="0"></el-option>
                  <el-option label="每个月" :value="1"></el-option>
                  <el-option label="三个月" :value="3"></el-option>
                  <el-option label="六个月" :value="6"></el-option>
                  <el-option label="一年" :value="12"></el-option>
                  <el-option label="无" :value="12000"></el-option>
                </el-select>
              </el-form-item>
             
              <el-form-item label="联系人">
                <el-input
                  v-model="detailForm.contactsName"
                  maxlength="10"
                  size="small"
                ></el-input>
              </el-form-item>
              <el-form-item label="经办人">
                <el-input
                  v-model="detailForm.handledByName"
                  maxlength="10"
                  size="small"
                ></el-input>
              </el-form-item>
              
            </div>
            <div class="flex-1">
              <el-form-item label="到期时间" prop="contractEndTime">
                <el-date-picker
                  v-model="detailForm.contractEndTime"
                  type="date"
                  placeholder="选择到期时间"
                  value-format="yyyy-MM-dd">
                </el-date-picker>
              </el-form-item>
            
              <el-form-item v-if="isflag" label="下次结算日期" prop="nextSettlementTime">
                <el-date-picker
                :disabled="disabled"
                  v-model="detailForm.nextSettlementTime"
                  type="date"
                  placeholder="选择结算时间"
                  value-format="yyyy-MM-dd">
                </el-date-picker>
              </el-form-item>
              <el-form-item v-else label="下次结算日期">
                <el-date-picker
                :disabled="disabled"
                  v-model="detailForm.nextSettlementTime"
                  type="date"
                  placeholder="选择结算时间"
                  value-format="yyyy-MM-dd">
                </el-date-picker>
              </el-form-item>
              <el-form-item label="联系电话">
                <el-input
                  v-model="detailForm.contactsTel"
                  size="small"
                ></el-input>
              </el-form-item>
              
            </div>
          </div>
          <div class="detail-content-body-div flex-1">
            <el-form-item label="分润比例"  prop="profitSettleRatio">
                <el-input
                  v-model="detailForm.profitSettleRatio"
                  size="small"
                  type="textarea"
                  :rows="4"
                  maxlength="100"
                  show-word-limit
                ></el-input>
              </el-form-item>
          </div>
        </el-form>
      </div>
      <!-- 表格 -->
      <div class="list-table">
        <el-table :data="tableData" :stripe="true" class="list_tb" border>
          <el-table-column
            prop="operationUserAccount"
            label="操作人"
            min-width="200"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="createdWhen"
            label="操作时间"
            min-width="110"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="operationContent"
            label="操作事项"
            min-width="170"
            align="center"
          >
            
          </el-table-column>
        </el-table>
      </div>
      <!-- 分页 -->
      <div class="list-pagination" >
        <ZD-pagination
          :pagination="pagination"
          v-on:pageUpdate="getListData"
        ></ZD-pagination>
      </div>
      <div class="detail-content-footer-div">
        <button class="common-bg-button" @click="submitForm('detailForm')">
          提 交
        </button>
        <!-- <button class="common-empty-button" @click="resetForm">取 消</button> -->
      </div>
    </div>
  </div>
</template>

<script>
import pageConfig from './page-config'
export default {
  data() {
    return {
      disabled:false,
      value1:'',
      value2:'',
      value3:'',
      pageConfig,
      editFlag: false,
      tableData:[],
      queryInfo: {
        operationBelongId: "",
      },
      pagination: pageConfig.pagination,
      pageTitle: '合同信息管理',
      // 默认值设置
      detailForm: {
        
      },
      url:'',
      searchBeginTime:[],
      isflag:true,
    }
  },
  methods: {
    handelChange(val){
      if(val == 12000){
        this.isflag = false
      }else{
        this.isflag = true
      }
    },  
      //判断是否为编辑模式
    init() {
      let _ = this
      _.url = _.$A.pilestation.contractAdd;
      // if (this.$store.state.editId) {
      //   this.editFlag = true
      //   this.pageTitle = ''
      //   this.url = this.$A.pileType.edit;
      //   this.getFormInfo()
      // }
      let url = _.$A.pilestation.getContract
      _.$H.get(_, url, {stationNo:_.$route.query.stationNo}).then((res) => {
        if(res.data.data){
          _.detailForm = res.data.data
          _.editFlag = true;
          _.url = _.$A.pilestation.contractEdit;
          _.disabled = true
          _.getListData(_.pagination, true);
        }else{
          _.editFlag = false;
          _.url = _.$A.pilestation.contractAdd;
          _.disabled = false
          // console.log(2);
        }
       
      })
    },
    // 获取表格数据
    getListData(pagination, reload = false) {
      let _ = this;

      _.queryInfo.pageNum = pagination.current - 1;
      if (reload) {
        this.pagination.current = 1;
        _.queryInfo.pageNum = 0;
      }
      _.queryInfo.pageSize = pagination.pageSize;
    
      // _.queryInfo.custNo = _.detailForm.custNo;
      _.queryInfo.operationBelongId = _.$route.query.stationNo;
      // _.queryInfo.stationDiscountNo = _.detailForm.stationDiscountNo;
      // _.queryInfo.operateName = _.detailForm.operateName;
      _.$H.get(_, _.$A.pilestation.stationContractLog, _.queryInfo).then((res) => {
       
        _.tableData = res.data.data.content || [];
        // _.tableData.forEach((item) => {
        //   item.content = JSON.parse(item.content);
        // });
        console.log(_.tableData);
        _.pagination.total = res.data.data.totalElements || 0;

        // _.$U.hideLoading(_);
      });
    },
    // 获取表单信息
    // getFormInfo() {
    //   let _ = this
    //   _.$S.getFormInfo(_, _.$A.pileType.detail + '/' + _.$store.state.editId, function(
    //     res
    //   ) {
    //     _.detailForm = res.data.data
    //   })
    // },
    // 表单提交
    submitForm(formName) {
      let _ = this
      _.detailForm.corpNo = _.$store.state.corpNo;
      _.detailForm.stationNo = _.$route.query.stationNo;
      console.log(_.detailForm);
      this.$refs[formName].validate((valid) => {
        if (valid) {
          _.$S.submitForm(
            _,
            _.url,
            _.editFlag,
            _.detailForm,
            pageConfig.listRouter
          )
        }
      })
    },
     
    // 取消
    resetForm() {
      this.$router.push({
        name: pageConfig.listRouter,
      })
    },
  },
  mounted() {
    this.init()
  },
}
</script>
